module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-page-app"
  }, [_c('DeveloperInfo'), _vm._v(" "), _c('router-view', {
    key: _vm.key
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21c8ac7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2413
// module chunks = 68